import { hotRank } from "@/mocks/blackmole";
import { barTone, chipTone } from "./tone";

const topTone = ["bg-primary-500", "bg-accent-500", "bg-secondary-500"];

export default function HotRank() {
  return (
    <section id="rank" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-700">
              <span className="inline-block h-px w-6 bg-primary-500"></span>
              热议榜 · 浓度即热度
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日话题热度 TOP 8
            </h2>
          </div>
          <span className="flex items-center gap-1.5 rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900">
            <i className="ri-bar-chart-2-line text-sm"></i>
            每小时按讨论量重排
          </span>
        </div>

        <div className="grid gap-x-8 gap-y-2 lg:grid-cols-2">
          {hotRank.map((item, i) => (
            <a
              key={i}
              href="#feed"
              className="group flex items-center gap-4 rounded-xl px-2 py-3 transition-colors hover:bg-background-100 md:px-3"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-black text-background-50 md:h-9 md:w-9 ${
                  i < 3 ? topTone[i] : "bg-foreground-200 text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <span className="flex flex-1 flex-col gap-1.5">
                <span className="flex items-center gap-2">
                  <span className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700 md:text-[15px]">
                    {item.title}
                  </span>
                  <span className={`whitespace-nowrap rounded-md px-1.5 py-0.5 text-[11px] font-semibold ${chipTone[i === 0 ? "accent" : "secondary"]}`}>
                    {item.trend}
                  </span>
                </span>
                <span className="flex items-center gap-3">
                  <span className={`h-1.5 flex-1 overflow-hidden rounded-full bg-background-200`}>
                    <span
                      className={`block h-full rounded-full ${barTone[i < 3 ? "primary" : "secondary"]}`}
                      style={{ width: `${item.heat}%` }}
                    ></span>
                  </span>
                  <span className="flex w-10 shrink-0 items-center justify-end gap-0.5 text-xs font-bold text-foreground-600">
                    <i
                      className={
                        item.up
                          ? "ri-arrow-up-line text-accent-600"
                          : "ri-arrow-down-line text-secondary-400"
                      }
                    ></i>
                    {item.heat}
                  </span>
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}